document.addEventListener("alpine:init", () => {
    const events = {
      productForm: {
        update: "swanky:product-form:update",
      },
    };
  
    Alpine.data("productForm", ({ initialVariantId, variants }) => ({
      selectedVariantId: initialVariantId,
      variantIdInput: undefined,
      variants,
  
      init() {
        this.variantIdInput = this.$el.querySelector("#product-select");
  
        const sizeInput = this.$el.querySelector("input[name='size']");
        if (sizeInput) {
          const observer = new MutationObserver((event) => {
            this.handleSizeUpdate(event);
          });
  
          observer.observe(sizeInput, {
            attributes: true,
            attributeFilter: ["value"],
          });
        }
      },
  
      handleSizeUpdate(event) {
        const formData = new FormData(this.$el);
        const data = Object.fromEntries(formData.entries());
        const selectedOptionTitle = event[0].target.dataset.rawSize;
  
        const matchingVariant = data.id
          ? this.variants.find(({ id }) => id.toString() === data.id.toString())
          : this.variants.find(
              ({ option1, option2 }) =>
                option1 === selectedOptionTitle || option2 === selectedOptionTitle
            );
  
        if (!matchingVariant) {
          console.warn("No matching variant ID found");
          return;
        }
  
        const customEvent = new CustomEvent(events.productForm.update, {
          detail: { variant: matchingVariant },
          bubbles: true,
        });
  
        document.dispatchEvent(customEvent);
      },
    }));
  
    Alpine.data("productPrice", (currency) => ({
      _price: 0,
      currency: currency || "GBP",
  
      set price(rawPrice) {
        this._price = parseInt(this.$el.dataset.price || 0);
        this.$el.dataset.price = rawPrice;
        this.$el.innerText = new Intl.NumberFormat(navigator.language, {
          style: "currency",
          currency: this.currency,
        }).format(rawPrice / 100);
      },
  
      init() {
        this._price = parseInt(this.$el.dataset.price || 0);
        document.addEventListener(
          events.productForm.update,
          this.handleVariantUpdate.bind(this)
        );
      },
  
      handleVariantUpdate(event) {
        if (!event.detail?.variant?.price) {
          console.warn("productPrice: No variant supplied in payload");
          return;
        }
  
        this.price = event.detail.variant.price;
      },
    }));
  
    Alpine.data("productCard", (currency) => ({
      _price: null,
      currency: currency || "GBP",
      selectedVariantId: null,
  
      get price() {
        if (!this._price) return null;
  
        return new Intl.NumberFormat(navigator.language, {
          style: "currency",
          currency: this.currency,
        }).format(this._price / 100);
      },
  
      set price(rawPrice) {
        this._price = rawPrice;
      },
  
      setSelectedVariant(id, price) {
        this.selectedVariantId = id;
        this.price = price;
      },
    }));
  });